export default "__VITE_ASSET__BH9o1tLn__"